import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://games.peachpreview.co.uk/api/v1";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const gameAPI = {
  getGames: () => api.get("/games"),

  getGame: (slug) => api.get(`/games/${slug}`),

  startSession: (slug, playerData) =>
    api.post(`/games/${slug}/start`, playerData),

  completeSession: (sessionToken, gameData) =>
    api.post(`/sessions/${sessionToken}/complete`, gameData),

  getLeaderboard: (slug, params = {}) =>
    api.get(`/games/${slug}/leaderboard`, { params }),

  getRecentWinner: (slug) => api.get(`/games/${slug}/recent-winner`),

  spinWheel: (sessionToken) => api.post(`/sessions/${sessionToken}/spin`),

  claimPrize: (claimCode, contactData) =>
    api.post(`/prizes/${claimCode}/claim`, contactData),

  requestContact: (contactData) => api.post("/contact-request", contactData),
};

// Add to existing api.js
export const swipeGameAPI = {
  getCards: () => api.get("/swipe-game/cards"),

  startSession: (playerData) => api.post("/swipe-game/start", playerData),

  recordSwipe: (sessionToken, swipeData) =>
    api.post(`/swipe-game/${sessionToken}/swipe`, swipeData),

  completeSession: (sessionToken) =>
    api.post(`/swipe-game/${sessionToken}/complete`),

  submitContact: (contactData) => api.post("/swipe-game/contact", contactData),

  getStats: () => api.get("/swipe-game/stats"),
};

export default api;
